import { SettingsMasterStep } from 'entities/settings-master/model/type';
import { ats_air_id, ats_water_id, hc_boiler_id, hc_dhw_id, hc_id, } from 'features/settings-master/model/default/ids';
import { removeNulls } from 'utils';
import { HeatingCircuit } from 'z3k-config';
export function getAdditionalGraphsConfig(path, config) {
    let boiler_graph = {
        title_block: 'Котёл',
        show_tooltip: true,
        show_legend: true,
        height: null,
        height_mobile: null,
        size_boolean_line: 12,
        bool_graph_on_main: false,
        sources: [],
    };
    if (path.includes(SettingsMasterStep.DigitalBus)) {
        const boiler_adapter_id = HeatingCircuit.get.byId(config, hc_boiler_id)
            ?.control_devices?.[0] ?? null;
        boiler_graph = {
            ...boiler_graph,
            sources: [
                {
                    class: 'Z3KOTZoneLineGraph',
                    params: {
                        object_id: boiler_adapter_id,
                        ot_field: 'cs',
                    },
                },
                {
                    class: 'Z3KOTZoneLineGraph',
                    params: {
                        object_id: boiler_adapter_id,
                        ot_field: 'bt',
                    },
                },
                {
                    class: 'Z3KOTZoneLineGraph',
                    params: {
                        object_id: boiler_adapter_id,
                        ot_field: 'dt',
                    },
                },
                {
                    class: 'Z3KOTZoneLineGraph',
                    params: {
                        object_id: boiler_adapter_id,
                        ot_field: 'rml',
                    },
                },
                {
                    class: 'Z3KOTZoneFlagGraph',
                    params: {
                        object_id: boiler_adapter_id,
                        ot_flag: 'ch',
                    },
                },
                {
                    class: 'Z3KOTZoneFlagGraph',
                    params: {
                        object_id: boiler_adapter_id,
                        ot_flag: 'dhw',
                    },
                },
            ],
        };
    }
    else {
        boiler_graph = {
            ...boiler_graph,
            bool_graph_on_main: true,
            sources: [
                {
                    class: 'HeatingCircuitSetpointTempGraphData',
                    params: {
                        object_id: hc_boiler_id,
                    },
                },
                {
                    class: 'HeatingCircuitWorkTimeGraphData',
                    params: {
                        object_id: hc_boiler_id,
                    },
                },
            ],
        };
    }
    let heating_circuit = {
        title_block: 'Отопление',
        show_tooltip: false,
        show_legend: true,
        height: null,
        height_mobile: 296,
        size_boolean_line: 5,
        bool_graph_on_main: true,
        sources: [
            {
                class: 'HeatingCircuitSetpointTempGraphData',
                params: {
                    object_id: hc_id,
                },
            },
            {
                class: 'HeatingCircuitTargetTempGraphData',
                params: {
                    object_id: hc_id,
                },
            },
            {
                class: 'HeatingCircuitWorkTimeGraphData',
                params: {
                    object_id: hc_id,
                },
            },
        ],
    };
    if (path.includes(SettingsMasterStep.AirControl) ||
        path.includes(SettingsMasterStep.InRoomTemp)) {
        const new_sources = [
            ...heating_circuit['sources'],
            {
                class: 'AnalogTemperatureGraphData',
                params: {
                    object_id: ats_air_id,
                },
            },
        ];
        heating_circuit = {
            ...heating_circuit,
            sources: new_sources,
        };
    }
    if (path.includes(SettingsMasterStep.WaterControl) ||
        path.includes(SettingsMasterStep.PZAControl)) {
        const new_sources = [
            ...heating_circuit['sources'],
            {
                class: 'AnalogTemperatureGraphData',
                params: {
                    object_id: ats_water_id,
                },
            },
        ];
        heating_circuit = {
            ...heating_circuit,
            sources: new_sources,
        };
    }
    let dhw_circuit = undefined;
    if (path.includes(SettingsMasterStep.BoilerDHW)) {
        dhw_circuit = {
            show_tooltip: false,
            show_legend: true,
            title_block: 'ГВС',
            sources: [
                {
                    class: 'HeatingCircuitSetpointTempGraphData',
                    params: {
                        object_id: hc_dhw_id,
                    },
                },
                {
                    class: 'HeatingCircuitTargetTempGraphData',
                    params: {
                        object_id: hc_dhw_id,
                    },
                },
                {
                    class: 'HeatingCircuitWorkTimeGraphData',
                    params: {
                        object_id: hc_dhw_id,
                    },
                },
            ],
            height: null,
            height_mobile: 210,
            size_boolean_line: 5,
            bool_graph_on_main: true,
        };
    }
    return removeNulls([boiler_graph, heating_circuit, dhw_circuit]);
}
